import {
  __spreadValues
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/utils.ts
function vs(...args) {
  var _a;
  let result = {};
  for (const arg of args) {
    if (arg == null || arg === false) {
      continue;
    }
    if (Array.isArray(arg)) {
      const [v, val] = arg;
      if (val == null) {
        continue;
      }
      const strVal = typeof val === "number" ? `${val}` : val;
      const match = (_a = v.match(/^var\((--.*)\)$/)) == null ? void 0 : _a[1];
      if (match != null) {
        result[match] = strVal;
      } else {
        result[v] = strVal;
      }
    } else {
      result = __spreadValues(__spreadValues({}, result), arg);
    }
  }
  return result;
}

export {
  vs
};
//# sourceMappingURL=chunk-56TZPABM.js.map
